import React from 'react'
import { connect } from 'react-redux'

class Contact extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className='settings-units-container'>
        < h3 > Contact Us</h3>
        <div style={{ padding: '5px', fontSize: '12px' }}>
          <p>
            We built this app with the goal of helping you own the outdoors, which is why your feedback is so important.</p>
          <h4 style={{ marginTop: '10px', marginBottom: '10px' }}>Having Technical Issues?</h4>
          <p>
            We work hard to assure you have a seamless experience, but if you do have a technical issue, please reach out so
            we can work to find a solution as quickly as possible.</p>
          <p style={{ marginTop: '10px', marginBottom: '10px' }}>
            Email us: <a style={{ color: 'rgb(144, 255, 0)' }}
              href="mailto:support@basemap.com">support@basemap.com</a>
          </p>
          <h4 style={{ marginTop: '10px', marginBottom: '10px' }}>Have Feedback or a Feature Request?</h4>
          <p>
            Have an idea for a new feature or just want to tell us about using our app on your last outdoor adventure? We
            would love to hear from you!</p>
          <p style={{ marginTop: '10px', marginBottom: '10px' }}>
            Email us: <a style={{ color: 'rgb(144, 255, 0)' }}
              href="mailto:feedback@basemap.com">feedback@basemap.com</a>
          </p>
          <img style={{ width: '100%', height: '100%' }}
            src="../../../../../../asset/Hiker-Basemap-39_cropped.jpg" />
          <div>
            <p>Version 3.0.0 Build 221 </p>
            <p> &copy; {new Date().getUTCFullYear()} BaseMap Inc</p>
          </div>
        </div>
      </div >
    )
  }
}


const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(Contact)